import React, { forwardRef, useState, useImperativeHandle } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd';
import moment from 'moment';
import { Form } from '@ant-design/compatible';

import { dayFormatType, isAfter } from '~helpers/day';

import Modal from 'common/components/modal';

const useStyles = makeStyles(theme => ({
  wrapper: {
    '& .ant-modal-body': {
      padding: '0 32px',
    },

    '& .ant-legacy-form-item-label': {
      lineHeight: '22px !important',
      color: theme.colors.titleColor,
      marginBottom: 8,
    },
  },
}));

const ScheduleModal = forwardRef(({ form, params = {}, handleSuccessCallback }, ref) => {
  const { getFieldDecorator, resetFields, validateFields } = form;
  const { t } = useTranslation();

  const classes = useStyles();

  const [visible, setVisible] = useState(false);

  const handleConfirmModal = () => {
    validateFields((err, values) => {
      if (!err) {
        const { publishedAt } = values;

        handleSuccessCallback({
          ...params,
          publishedAt: moment(publishedAt).format(dayFormatType.FILTERPARAMS),
        });
      }
    });
  };

  const handleCloseModal = () => {
    setVisible(false);
  };

  useImperativeHandle(ref, () => ({
    visible,
    handleOpenModal: () => {
      resetFields(['publishedAt']);
      setVisible(true);
    },
    handleCloseModal,
  }));

  return (
    <Modal
      visible={visible}
      width={446}
      title={t('content.release_note.modal.scheduled.title')}
      okText={t('content.release_note.modal.scheduled.btn.publish')}
      wrapClassName={classes.wrapper}
      destroyOnClose={true}
      onOk={handleConfirmModal}
      onCancel={handleCloseModal}
    >
      <Form>
        <Form.Item label={t('content.release_note.modal.scheduled.label.publish_date')}>
          {getFieldDecorator('publishedAt', {
            rules: [
              {
                required: true,
                message: t('content.release_note.modal.create.error.empty'),
              },
            ],
          })(<DatePicker style={{ width: '100%' }} disabledDate={date => isAfter(date)} />)}
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default Form.create({
  name: 'schedule-modal',
})(ScheduleModal);
